<template>
    <router-view></router-view>

    <!-- <div class="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed" style="background-image: url('/media/illustrations/sketchy-1/14.png')">
        <div class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
            <a href="#" class="mb-12">
                <img alt="Logo" src="/logo/virtaragroup-logo.png" class="h-45px"/>
            </a>

            <router-view></router-view>
        </div>
       <div class="d-flex flex-center flex-column-auto p-10">
            <div class="d-flex align-items-center fw-bold fs-6">
                <a href="#" class="text-muted text-hover-primary px-2">About</a>

                <a href="#" class="text-muted text-hover-primary px-2">Contact</a>

                <a href="#" class="text-muted text-hover-primary px-2">Contact Us</a>
            </div>
        </div>
    </div>-->
</template>

<script>
import {Actions} from "@/store/enum/StoreEnums";

export default {
    name: "auth",
    data() {
        return {
            theme: 'system'
        }
    },
    components: {},
    mounted() {
        this.$store.dispatch(Actions.ADD_BODY_CLASSNAME, "bg-body");
        this.initTheme()
    },
    unmounted() {
        this.$store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "bg-body");
    },
    methods: {
        initTheme() {
            const saved = localStorage.getItem('app_theme') || 'system'
            this.theme = saved
            this.applyTheme(saved)

            window.matchMedia('(prefers-color-scheme: dark)')
                .addEventListener('change', () => {
                    if (this.theme === 'system') {
                        this.applyTheme('system')
                    }
                })
        },
        applyTheme(mode) {
            let theme = mode

            if (mode === 'system') {
                theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
            }

            const html = document.documentElement

            html.setAttribute('data-bs-theme', theme)
            html.setAttribute('data-theme', theme)

            html.classList.remove('dark', 'light')
            html.classList.add(theme)
        },
    }
};
</script>
